
import { ref } from "vue";
import { uploadFileChunked } from "@/utils/uploadChunk";
import { useToast } from "primevue/usetoast";
import { VideoDetail } from "@/models/videoDetail";
import EvaluationRepository from "@/services/EvaluationRepository";
import { FileDelete } from "@/models/fileDelete";
import axios from "axios";


interface FileDetail {
  nameFile: string;
  value: File;
}

export default {
  name: "UploadFile",
  setup() {
    const toast = useToast();

    const title = ref("");
    const videoInput = ref<HTMLInputElement | null>(null);
    const videoFile = ref<FileDetail | null>(null);
    const priceFile = ref<FileDetail | null>(null);
    const processFile = ref<FileDetail | null>(null);
    const surveyFile = ref<FileDetail | null>(null);
    const doctorFile = ref<FileDetail | null>(null);

    const loadingVideo = ref(false);
    const loadingPrice = ref(false);
    const loadingProcess = ref(false);
    const loadingSurvey = ref(false);
    const loadingDoctor = ref(false);

    // 🔥 CHỈ THÊM CÁI NÀY
    const videoPercent = ref(0);

    const listVideo = ref<VideoDetail[]>([]);
    const fileDelete = ref({} as FileDelete);

    const getListVideo = () => {
      EvaluationRepository.getListVideoDetail().then(res => {
        listVideo.value = res.data;
      });
    };

    const deleteVideo = (id: number) => {
      EvaluationRepository.deleteVideo(id).then(() => {
        toast.add({
          severity: "info",
          summary: "Xóa",
          detail: "Xóa tập tin thành công",
          life: 4000
        });
        getListVideo();
      });
    };

    getListVideo();

    const open = (id: string) => document.getElementById(id)?.click();
    const openVideoFile = () => open("videoFile");
    const openPriceFile = () => open("priceFile");
    const openProcessFile = () => open("processFile");
    const openSurveyFile = () => open("surveyFile");
    const openDoctorFile = () => open("doctorFile");

    const changePdf = (e: Event, target: any) => {
      const f = (e.target as HTMLInputElement).files?.[0];
      if (!f || f.type !== "application/pdf") return;
      target.value = { nameFile: f.name, value: f };
    };

    const videoChange = (e: Event) => {
      const f = (e.target as HTMLInputElement).files?.[0];
      if (f) videoFile.value = { nameFile: f.name, value: f };
    };

    // =================== VIDEO UPLOAD (CÓ %) ===================
    const uploadVideo = async () => {
      if (!title.value || !videoFile.value) return;

      loadingVideo.value = true;
      videoPercent.value = 0;

      try {
        await uploadFileChunked(
            videoFile.value.value,
            { Title: title.value },
            (percent) => {
              videoPercent.value = percent;
            }
        );

        toast.add({
          severity: "success",
          summary: "Thành công",
          detail: "Upload video thành công",
          life: 3000
        });

        title.value = "";
        videoFile.value = null;
        getListVideo();
      } catch (e) {
        toast.add({
          severity: "error",
          summary: "Lỗi",
          detail: "Upload video thất bại",
          life: 4000
        });
      } finally {
        loadingVideo.value = false;
        videoPercent.value = 0;
        videoFile.value = null;

        // 🔥 RESET INPUT FILE
        if (videoInput.value) {
          videoInput.value.value = "";
        }
      }
    };

    // =================== PDF UPLOAD (GIỮ NGUYÊN) ===================
    const upload = async (url: string, file: any, loading: any) => {
      if (!file.value) return;
      loading.value = true;
      const fd = new FormData();
      fd.append("FormFiles", file.value.value);
      await axios.post(url, fd);
      loading.value = false;
      file.value = null;
      toast.add({ severity: "success", summary: "Thành công", detail: "Upload thành công", life: 2000 });
    };

    return {
      title,
      videoFile, priceFile, processFile, surveyFile, doctorFile,
      loadingVideo, loadingPrice, loadingProcess, loadingSurvey, loadingDoctor,
      videoPercent,

      openVideoFile,
      openPriceFile,
      openProcessFile,
      openSurveyFile,
      openDoctorFile,

      videoChange,
      priceChange: (e: Event) => changePdf(e, priceFile),
      processChange: (e: Event) => changePdf(e, processFile),
      surveyChange: (e: Event) => changePdf(e, surveyFile),
      doctorChange: (e: Event) => changePdf(e, doctorFile),

      uploadVideo,
      uploadPrice: () => upload("/api/File/UploadPrice", priceFile, loadingPrice),
      uploadProcess: () => upload("/api/File/UploadProcess", processFile, loadingProcess),
      uploadSurvey: () => upload("/api/File/UploadSurvey", surveyFile, loadingSurvey),
      uploadDoctor: () => upload("/api/File/UploadDoctor", doctorFile, loadingDoctor),

      listVideo,
      deleteVideo,
      videoInput
    };
  }
};
